import React, { lazy, Suspense } from 'react';
import DeviationPageLoader from './_partials/DeviationPageLoader';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '../utils/webpack/chunkRetry';
const DeviationPage = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "devpage", webpackPrefetch: true */ './index')));
export const LoadableDeviationPage = ({ isWholePageLoading, deviation })=>{
    if (isWholePageLoading) {
        return /*#__PURE__*/ React.createElement(DeviationPageLoader, null);
    }
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "LoadableDeviationPage"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(DeviationPageLoader, null)
    }, /*#__PURE__*/ React.createElement(DeviationPage, {
        deviation: deviation
    })));
};
LoadableDeviationPage.displayName = 'LoadableDeviationPage';
export default LoadableDeviationPage;
